<style lang="scss" scoped>
 .company-page {
   min-height: 100%;
   background-color: #f8f8fb;
   .info-container {
     width: 702px;
     margin: 60px auto;
     padding: 40px 24px;
     background-color: #fff;
     margin-bottom: 0px;
     .price-area {
       margin: 40px auto;
       text-align: center;
       font-size: 40px;
       color: #2a2a30;
       font-weight: 600;
     }
     .price-methods {
       text-align: center;
     }
     .tips {
       margin: 30px auto;
       text-align: center;
       padding: 0 20px;
       font-size: 24px;
       color: #2a2a30;
     }
     .account-container {
       padding: 24px;
       background-color: #f8f8fb;
       .row {
         display: flex;
         margin-bottom: 20px;
         .label {
           text-align: left;
           width: 150px;
           font-size: 26px;
           color: #a4a5ef;
         }
         .value {
           font-size: 26px;
           color: #2a2a30;
           flex: 1;
           display: flex;
           align-items: center;
         }
         .copy-btn {
           margin-left: 15px;
           height: 30px;
           width: 60px;
          //  background-color: #ccc;
           color: #b1b1b2;
           border: 1px solid #b1b1b2;
           font-size: 20px;
           display: flex;
           justify-content: center;
           align-items: center;
         }
       }
     }
   }
   .info-container_two {
     margin-top: 0;
   }
 }
</style>

<template>
  <div class="company-page">
    <div class="info-container">
      <div class="price-area">￥{{mount}}</div>
      <div class="price-methods">方式一</div>
      <div class="tips">请通过网银、或前往银行转账完成大额支付，转账时请备注手机号，超时未支付平台将关闭订单</div>
      <div class="account-container">
        <div class="row">
          <div class="label">汇款金额</div>
          <div class="value">￥{{mount}}</div>
        </div>
        <div class="row">
          <div class="label">账户名</div>
          <div class="value">
            <div class="content">图灵深视(北京)科技有限公司 </div>
            <div 
              class="copy-btn"
              v-clipboard="() => '图灵深视（北京）科技有限公司'"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              复制
            </div>
          </div>
        </div>
        <div class="row">
          <div class="label">账户</div>
          <div class="value">
            <div class="content">77190122000000125 </div>
            <div 
              class="copy-btn"
              v-clipboard="() => '77190122000000125'"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              复制
            </div>
          </div>
        </div>
        <div class="row">
          <div class="label">开户行</div>
          <div class="value">
            <div class="content">宁波银行北京航天桥支行</div>
            <div 
              class="copy-btn"
              v-clipboard="() => '宁波银行北京航天桥支行'"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              复制
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-container_two info-container">
      <div class="price-methods">方式二</div>
      <div class="tips">请通过支付宝转账，转账时请备注手机号，超时未支付平台将关闭订单</div>
      <div class="account-container">
        <div class="row">
          <div class="label">汇款金额</div>
          <div class="value">￥{{mount}}</div>
        </div>
        <div class="row">
          <div class="label">账户名</div>
          <div class="value">
            <div class="content">图灵深视(北京)科技有限公司 </div>
            <div 
              class="copy-btn"
              v-clipboard="() => '图灵深视（北京）科技有限公司'"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              复制
            </div>
          </div>
        </div>
        <div class="row">
          <div class="label">账户</div>
          <div class="value">
            <div class="content">bjturingsenseai@163.com </div>
            <div 
              class="copy-btn"
              v-clipboard="() => 'bjturingsenseai@163.com'"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              复制
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import Vue from 'vue'


export default {
  data() {
    return {
      mount: 0
    }
  },
  created() {
    const { mount } = this.$route.query
    this.mount = mount
  },
  methods: {
    onCopy() {
      Toast.success('复制成功')
    },
    onError() {
      Toast.fail('复制失败')
    }
  }
}
</script>